module.exports = __webpack_public_path__ + "public/img/线性向下图标.465f08cf.svg";